<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02"><span>MEDIA STUDIO</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Ouça os podcasts para melhorar e praticar seu inglês.</p>
      </div>
    </div>
    <!-- <div style="height: 550px;" class="relative box-content shadow-box box-content-border hidden min-height container justify-content-center wrap">
      <div class="search container">
        <div style="background: #dfdfdf;" class="input-space container align-items-center">
          <input type="text" placeholder="Digite o assunto do conteudo para procurar" class="input" v-model="filter">
        </div>
        <button class="container btn btn-orange align-items-center">Buscar</button>
        <div class="container align-items-center" id="filtervp">
          <div class="boxToggle">
            <span style="">
              <div class="toggle">
                <input type="checkbox" id="checkboxvideo" class="check" v-model="checked">
                <b class="b switch"></b>
                <b class="b track"></b>
              </div>
            </span>
            <label for="checkboxvideo">VIDEO</label>
          </div>
          <div class="boxToggle">
            <span style="">
              <div class="toggle">
                <input type="checkbox" id="checkboxvideo" class="check" v-model="checked">
                <b class="b switch"></b>
                <b class="b track"></b>
              </div>
            </span>
            <label for="checkboxvideo">PODCAST</label>
          </div>
        </div>
      </div>
      <div class="boxContent container wrap">
        <div class="boxContent__base container" :class="{ corPodcast: media.type == 'audio', corVideo: media.type == 'video' }" v-for="(media, index) in medias" @click="open(media)">
          <div class="boxContent__base__label">
            <div class="boxContent__base__label__type">
              <span class="boxContent__base__label__type__number">#{{ index + 1 }}</span>
              <span class="boxContent__base__label__type__media" :class="{ podcast: media.type == 'audio', video: media.type == 'video' }">{{ media.type == 'video' ? 'Video' : 'Podcast' }}</span>
            </div>
            <h1>{{ media.title }}</h1>
            <p>{{ media.description }}</p>
          </div>
          <img :src="media.img" :alt="media.title">
        </div>
      </div>
      <div class="pagination container">
        <div class="pagination__prev">
          prev.
        </div>
        <ul class="pagination__numbers container">
          <li>1</li>
          <li>2</li>
          <li>3</li>
          <li>4</li>
          <li>5</li>
        </ul>
        <div class="pagination__next">
          next
        </div>
      </div>
      <div>
      </div>
      <modal :show="showModal">
        <div class="media-modal" v-if="showModal && !!media">
          <div class="media-modal__header">
            <h3>{{ media.title }}</h3>
          </div>
          <div class="media-modal__section">
            <div class="media-modal__section__item media-modal__section__item--media">
              <video :src="media.src" v-if="media.type == 'video'" controls/>
              <audio :src="media.src" v-else-if="media.type == 'audio'" controls/>
            </div>
            <div class="media-modal__section__item media-modal__section__item--description">
              <p>{{ media.description }}</p>
            </div>
          </div>
        </div>
      </modal>
    </div> -->
    <div class="box-content shadow-box box-content-border hidden min-height container justify-content-center align-items-center">

      <div class="box--item animation-bottom animation-delay-05">
        <h4>COMING SOON</h4>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  import modal from '@/components/modal'
  import modalBus from '@/components/modal/modalBus'

  export default {
    components: {
    },
    data () {
      return {
        form: {
          name: '',
          mail: '',
          region: '',
          resource: ''
        },
        media: null,
        showModal: false
      }
    },
    computed: {
      medias () {
        return [
          {
            id: 1,
            type: 'audio',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'https://sampleswap.org/mp3/artist/2/canton_Invisible-Space-Journeys-160.mp3'
          },
          {
            id: 2,
            type: 'video',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'http://www.html5videoplayer.net/videos/toystory.mp4'
          },
          {
            id: 3,
            type: 'video',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'http://www.html5videoplayer.net/videos/toystory.mp4'
          },
          {
            id: 4,
            type: 'audio',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'https://sampleswap.org/mp3/artist/2/canton_Invisible-Space-Journeys-160.mp3'
          },
          {
            id: 5,
            type: 'audio',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'https://sampleswap.org/mp3/artist/2/canton_Invisible-Space-Journeys-160.mp3'
          },
          {
            id: 6,
            type: 'video',
            img: 'http://web.tradekorea.com/product/742/718742/TEST%20IMG%20DB006-1.jpg',
            title: 'The garyvee show',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            src: 'http://www.html5videoplayer.net/videos/toystory.mp4'
          }
        ]
      }
    },
    methods: {
      open (media) {
        this.media = media
        this.showModal = true
      },
      close () {
        this.showModal = false
        this.media = null
      },
      onSubmit () {
        console.log('submit!')
      }
    },
    components: {
      modal
    },
    mounted () {
      modalBus.$on('close', this.close)
    },
    beforeDestroy () {
      modalBus.$off('close', this.close)
    }
  }
</script>

<style media="screen" lang="scss" scoped>

.search{
  height: 35px;
  width: 100%;

 & .input-space{
   & .input{
    text-transform: uppercase;
    font-family: volte;
    font-weight: 300;
    font-size: 12px;
    letter-spacing: .7px;
    &::placeholder{
      color: rgb(156, 156, 156);
    }
   }
   &:focus-within{
      box-shadow: none;
    }
 }
 & button{
   border-radius: 300px;
   padding: 5px 20px;
   margin: 0px 10px;
 }

  & .boxToggle{
    border: solid 2px rgb(121, 121, 121);
    color: #9d9d9d;
    width: 125px;
    height: 30px;
    font-size: 13px;
    margin: 0px 5px;
    padding: 5px 10px;
    border-radius: 300px;
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;

    &.boxToggle:first-child{
      width: 100px;
    }

    .toggle {
      position: absolute;
      top: 3px;
      left: 5px;
      width: 40px;
      height: 20px;
      border-radius: 100px;
      background-color: #ddd;
      // margin: -20px -40px;
      overflow: hidden;
      box-shadow: inset 0 0 2px 1px rgba(0,0,0,.05);
    }

    .check {
      position: absolute;
      display: block;
      cursor: pointer;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 6;
    }

    .check:checked ~ .track {
      box-shadow: inset 0 0 0 20px #1FE59D;
    }

  .check:checked ~ .switch {
    right: 2px;
    left: 22px;
    transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
    transition-property: left, right;
    transition-delay: .05s, 0s;
  }

  .switch {
    position: absolute;
    left: 2px;
    top: 2px;
    bottom: 2px;
    right: 22px;
    background-color: #fff;
    border-radius: 36px;
    z-index: 1;
    transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
    transition-property: left, right;
    transition-delay: 0s, .05s;
    box-shadow: 0 1px 2px rgba(0,0,0,.2);
  }

  .track {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
    box-shadow: inset 0 0 0 2px rgba(0,0,0,.05);
    border-radius: 40px;
  }

}

}

.boxContent{
  width: 100%;
  height: 420px;

  &__base{
    height: 130px;
    width: 360px;
    letter-spacing: .6px;
    flex-basis: calc(50% - 20px);
    flex-grow: 1;
    margin: 7.5px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    justify-content: space-between;

    @media screen and (max-width: 1010px){
      flex-basis: 100%;
    }

    &.corPodcast{
      background: linear-gradient(195deg, #c2013b 35%, #ff6f00 105%);
       h1{
        color: #FFC400;
      }
      span:first-child{
        background: #FFC400;
        color: #c2013b;
      }

      &::after{
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        font-size: 25px;
        color: white;
        transition: all .2s ease-in;
      }

      &:hover::after{
      cursor: pointer;
      content: "ENTER";
      font-size: 25px;
      color: white;
      padding: 20px;
      position: absolute;
      background: rgba(255, 0, 36, 0.73);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    }
     &.corVideo{
      background: linear-gradient(195deg, #0155c2 35%, #01bbc2 105%);
       h1{
        color: #FF9AD6;
      }
      span:first-child{
        background: #FF0099;
        color: #ffffff;
      }
       &::after{
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        font-size: 25px;
        color: white;
        transition: all .2s ease-in;
      }

      &:hover::after{
      cursor: pointer;
      content: "ENTER";
      font-size: 25px;
      color: white;
      padding: 20px;
      position: absolute;
      background: rgba(0, 89, 255, 0.73);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    }

    & img{
      width: 180px;
      border-radius: 10px;
    }
    &__label{
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      & p{
        color: white;
        font-weight: 200;
        font-size: 12px;
        margin-bottom: 5px;
      }

      & h1{
        font-weight: 400;
        font-size: 15px;
        // color: #FFC400;
        text-transform: uppercase;
      }

      &__type{
        margin: 5px 0px 5px 0px;

        & span{
          font-weight: 400;
          padding: 3px 10px;
          margin: 0px 5px 0px 0px;
          border-radius: 100px;
          font-size: 12px;
          text-transform: uppercase;
        }
        &__media.podcast{
          background: #ffffff;
          color: #c2013b;
        }
        &__media.video{
          background: #ffffff;
          color: #0059ac;
        }
      }
    }
  }
}
.pagination{
  width: 100%;
  height: 20px;
  margin: 20px 10px 0px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 300;
  // background: #ff6f00;

  &__next{
    padding: 5px 10px;
    border-radius: 100px;
    background: #FFB300;
    color: #C70F31;
  }
  &__prev{
    padding: 5px 10px;
    border-radius: 100px;
    background: #FFB300;
    color: #C70F31;
  }
  &__numbers{
    list-style: none;
    margin: 0px 10px;

    & li{
      padding: 5px 10px;
      border-radius: 100px;
      background: #D4D4D4;
      color: #656565;
      margin: 0px 3px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/podcast/index.vue